import { getInstance as getDynamicReducerInstance } from 'lib/DynamicReducer/singleton';

import createInterface from './index';

const registerSelf = (store) => {
    const notificationInterface = createInterface(store);
    const { reducer, reducerNamespace, Component: Notification } = notificationInterface;

    if (!store.getState()[reducerNamespace]) {
        const dynamicReducer = getDynamicReducerInstance();

        dynamicReducer.registerNamespace(reducerNamespace, reducer);
        store.replaceReducer(dynamicReducer.createReducer());
    }

    return Notification;
};

export default registerSelf;
